module.exports = __webpack_public_path__ + "static/media/vertical01.d020b097.jpeg";